import React, { useState, useContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { io } from "socket.io-client";
import _ from "lodash";
import moment from "moment";

import "antd/dist/antd.css";
import "../../components/Navbar.css";
import "./SuperCcDashboard.css";

import {
  Badge,
  Button,
  Col,
  Layout,
  Menu,
  Row,
  Skeleton,
  Spin,
  Tooltip,
} from "antd";
import {
  BellOutlined,
  CalendarOutlined,
  CommentOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DiffOutlined,
  MailOutlined,
  //MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  MessageOutlined,
  UserOutlined,
  //VideoCameraOutlined,
  //UploadOutlined,
  SnippetsOutlined,
  TeamOutlined,
  HomeOutlined,
  ToolOutlined,
} from "@ant-design/icons";

// import { Care } from '../../../../caregiver-api/util/constants';
import { Care, Url, Roles } from "../../constants/Global";

import CaregiverContext, {
  CaregiverProvider,
} from "../../context/CaregiverProvider";

import useAuth from "../../hooks/useAuth";
import useMclAuth from "../../hooks/useMclAuth";
import Dashboard from "./Dashboard";

// import Profile from "../../components/Profile";
// import ProfileRibbon from "../../components/ProfileRibbon";
import NavHeadItemsAfterLogin from "../../components/NavHeadItemsAfterLogin";

import ClientLeads from "./ClientLeads";

import MyCC from "./MyCC";

import Partnerships from "./Partnerships";

import SCCKBOverview from "./SCCKBOverview";
import Reports from "./Reports";
import { openNotification } from "../../components/Various";
import SocketContext from "../../context/SocketContext";
import MessagingV2 from "../../components/MessagingV2";
import TSMessaging from "./TSMessaging";

const { Header, Sider, Content, Footer } = Layout;

const MESSAGES_SUPPORT_LIST = "/messages/status/support";
const CHAT_SUPPORT = "support";
const OLDEST_DATE = "1970-01-01";

const Home = () => {
  const mclAuth = useMclAuth();
  const { auth } = useAuth();
  const [cg, setCg] = useState({});

  const [isMsg, setIsMsg] = useState(false);
  const [supportStatus, setSupportStatus] = useState({});
  const [isLoadingCg, setIsLoadingCg] = useState(false);
  const [isLoadingChats, setIsLoadingChats] = useState(false);
  const [currentChat, setCurrentChat] = useState(null);
  const [chats, setChats] = useState(null);
  const [error, setError] = useState("");
  const [socket, setSocket] = useState(undefined);
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);

  const navigate = useNavigate();
  const { pageContent, setPageContent } = useContext(CaregiverContext);
  // const [giverCare, setGiverCare] = useContext(CaregiverContext);

  //console.log('auth:', JSON.stringify(auth))

  //const [pageContent, setPageContent] = useState(0);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    setIsLoadingCg(true);
    mclAuth
      .get(Url.CONCIERGES.concat("/", auth?.id))
      .then((res) => {
        setCg(res.data);
        setIsLoadingCg(false);
      })
      .catch((error) => {
        openNotification({
          message: error.message,
          status: "500",
          title: "500",
          subTitle: "Failed to get care concierge clients",
        });
        setIsLoadingCg(false);
      });
  }, [auth.id, mclAuth]);

  useEffect(() => {
    setIsLoadingChats(true);
    let status = cg?.supportStatus || {};
    console.log("support status:", status);
    setSupportStatus(status);
    mclAuth
      .get(MESSAGES_SUPPORT_LIST)
      .then((res) => {
        // console.log("response", res.data);
        const clients = res.data;
        // chats[currentChat].messages = [...chats[currentChat].messages, res.data]
        // setMessages(chats[currentChat].messages)
        const tmpChats = clients.map((c) => ({
          type: CHAT_SUPPORT,
          userId: c?.user._id,
          name: c?.user?.firstName.concat(
            " ",
            c?.user?.lastName /*, ' - ', r.circleId.firstName*/
          ),
          msgLast: c?.msgLast?.sentAt || OLDEST_DATE,
          //"hasNew": false,
          hasNew: moment(c?.user?.msgLast?.sentAt || OLDEST_DATE).isAfter(
            status?.[c?.user?._id] || OLDEST_DATE
          ),
        }));
        // console.log('chats:', tmpChats)
        setChats(tmpChats);
        checkNewMsg(tmpChats);
        setIsLoadingChats(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoadingChats(false);
        console.log(error);
      });
  }, [cg.relationships]);

  const initializeSocket = (token) => {
    const socket = io(process.env.REACT_APP_MCL_STATIC, {
      auth: {
        token: token,
      },
    });
    setSocket(socket);
  };

  useEffect(() => {
    console.log("set current circle to 0");
    return () => {
      socket?.disconnect();
    };
  }, []);

  useEffect(() => {
    if (auth?.accessToken) {
      console.log("initializeSocket");
      initializeSocket(auth?.accessToken);
    }
  }, [auth]);

  const checkNewMsg = (valChats) => {
    let allOld = valChats.every(function (c) {
      return !c.hasNew;
    });

    setIsMsg(!allOld);
  };

  const getLabel = (key) => {
    return pageDetails[key].label;
  };

  window.onpopstate = () => {
    navigate("/supercierge/dashboard");
  };

  const pageDetails = {
    home: {
      label: "Home",
      icon: <HomeOutlined />,
      element: <Dashboard setPage={setPageContent} getLabel={getLabel} />,
    },
    cc: {
      label: "Concierges",
      icon: <TeamOutlined />,
      element: <MyCC setPage={setPageContent} />,
    },
    clientLeads: {
      label: "Client Leads",
      icon: <ContactsOutlined />,
      element: <ClientLeads setPage={setPageContent} />,
    },
    reports: {
      label: "Reports",
      icon: <SnippetsOutlined />,
      element: <Reports setPage={setPageContent} />,
    },
    kb: {
      label: "Knowledge Base",
      icon: <DatabaseOutlined />,
      element: <SCCKBOverview cg={cg} />,
    },
    chat: {
      label: "Messaging",
      icon: <MessageOutlined />,
      hide: false,
      element: <MessagingV2 cg={cg} portal={Roles.SUPER_CONCIERGE} />,
    },
    partner: {
      label: "Partnerships",
      icon: <ContactsOutlined />,
      element: <Partnerships setPage={setPageContent} />,
    },
    // { 'label': 'Templates/Tools', 'icon': <ToolOutlined />, 'element': <p>Contact MyCareLinq</p> },
    // { 'label': 'Calendar', 'icon': <CalendarOutlined />, 'element': <p>Calendar</p> },
  };

  const pageDetailsKeys = Object.keys(pageDetails);
  const menuItemsKeys = new Array();
  pageDetailsKeys.map((key) => {
    if (!pageDetails[key]?.hide) {
      menuItemsKeys.push(key);
    }
  });
  const menuItems = menuItemsKeys.map((item, index) => {
    if (!item?.hide) {
      return {
        key: index.toString(),
        label: pageDetails[item].label,
        icon: pageDetails[item].icon,
      };
    }
  });

  const showProfileDrawer = () => {
    // console.log("Enter showProfileDrawer()");
    setOpenProfileDrawer(true);
  };

  const showContent = (pageSelect) => {
    //return (pageSelect === 0) ? <Dash setPage={setPageContent} /> : contentDesc[pageSelect];
    // console.log(menuItems[pageSelect]['element']);
    // console.log(
    //   "***" +
    //     showContent.name +
    //     " pageSelect is null? " +
    //     (pageSelect == null) +
    //     " pageSelect: " +
    //     pageSelect
    // );
    if (pageSelect == null || pageSelect === 0) {
      pageSelect = "home";
    }
    return pageDetails[pageSelect].element;
    // return pageDetails[pageSelect].element;
  };

  const onClickMenuItem = ({ item, key, keyPath, selectedKeys, domEvent }) => {
    // console.log("click key: " + key + " kpath: " + keyPath);
    setPageContent(menuItemsKeys[key]);
  };

  return (
    <SocketContext.Provider value={socket}>
      <Layout className="sccdash-layout">
        <Header className="sccdash-acct-header py-0 px-2 flex flex-row">
          {isLoadingCg || _.isEmpty(cg) ? (
            <Spin />
          ) : (
            <NavHeadItemsAfterLogin
              cg={cg}
              role={Roles.SUPER_CONCIERGE}
              showProfileDrawer={showProfileDrawer}
              isMsg={isMsg}
              showContent={showContent}
              setPageContent={setPageContent}
            />
          )}
        </Header>
        <Layout
          style={{
            minHeight: "calc(100vh - 66px)",
            minHeight: "calc(100dvh - 66px)",
          }}
        >
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={() => setCollapsed(!collapsed)}
            trigger={
              collapsed ? <MenuUnfoldOutlined /> : <MenuUnfoldOutlined />
            }
            style={{ background: "white" }}
            id="sccdash-sider"
          >
            <Menu
              theme="light"
              mode="inline" /* inline, vertical, horizontal */
              onClick={onClickMenuItem}
              multiple={false}
              defaultSelectedKeys={["home"]}
              selectedKeys={menuItemsKeys.indexOf(pageContent).toString()}
              items={menuItems}
              style={{
                color: "#10082d",
                backgroundColor: "white",
                height: "100%",
                borderRight: 0,
              }}
            />
          </Sider>
          <Layout>
            <Content
              className="site-layout-background"
              style={{
                /*margin: '24px 16px',*/
                padding:
                  !_.isEmpty(pageDetails) &&
                  pageDetails[pageContent]?.label === "Messaging"
                    ? 0
                    : 24,
                minHeight: "calc(100vh - 66px)",
                /*height: '100vh'*/
              }}
            >
              {isLoadingCg || _.isEmpty(cg) ? (
                <Skeleton active />
              ) : (
                showContent(pageContent)
              )}
              {/* Content */}
            </Content>
            {pageContent !== "chat" && (
              <Footer className="block fixed w-full bottom-0 text-[0.75rem] text-center font-thin text-primary-purple">
                Copyright &copy; 2021, 2023{" "}
                <a href="https://mycarelinq.com">
                  <strong>My CareLinq, Inc.</strong>
                </a>{" "}
                All Rights Reserved.
              </Footer>
            )}
          </Layout>
        </Layout>
      </Layout>
    </SocketContext.Provider>
  );
};

const Test = () => {
  return <div>Just a Test</div>;
};
const Supercierge = () => {
  return (
    <CaregiverProvider>
      <Routes>
        <Route exact path="/" element={<Home />} />
      </Routes>
    </CaregiverProvider>
  );
};

export default Supercierge;
